import * as React from "react";
import GithubLogo from "../assets/icons/github.svg";
import LinkedInLogo from "../assets/icons/linkedin.svg";
import DribbbleLogo from "../assets/icons/dribble.svg";
import BehanceLogo from "../assets/icons/behance.svg";
import SpotifyLogo from "../assets/icons/spotify.svg";
import Question from "../assets/icons/question.svg";

export const renderLogoIcon = (icon, classes) => {
  switch (icon) {
    case "github":
      return <GithubLogo className={classes} />;
    case "linkedin":
      return <LinkedInLogo className={classes} />;
    case "dribbble":
      return <DribbbleLogo className={classes} />;
    case "behance":
      return <BehanceLogo className={classes} />;
    case "spotify":
      return <SpotifyLogo className={classes} />;
    default:
      return <Question className={classes} />;
  }
};
